import styled from "@emotion/styled"

import { rgba } from "utils/cssUtils"

export const InputContainer = styled.div`
  position: relative;
  display: flex;
  width: 100%;
`

export const Input = styled.input<{ hasError?: boolean }>`
  width: 100%;
  max-height: 50px;
  padding: 12px 15px;
  ${p => p.theme.typography.standard.size_15px.normal()}
  color: ${p => p.theme.colors.neutralExtraDark};
  background-color: transparent;
  border: 1px solid ${p => rgba(p.theme.colors.primaryMedium, 0.15)};
  border-radius: 2px;

  ::placeholder {
    color: ${p => rgba(p.theme.colors.primaryMedium, 0.5)};
  }

  :focus {
    outline: transparent;
    border: 1px solid ${p => p.theme.colors.accentMedium};
  }

  ${p =>
    p.hasError &&
    `
    border-color: ${rgba(p.theme.colors.failureMedium, 0.7)} !important;

    ::placeholder {
      color: ${p.theme.colors.failureMedium} !important;
    }
  }`}
`

export const Alert = styled.div`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translate(0, -50%);
  display: flex;
  align-items: center;

  :hover {
    cursor: pointer;
  }
`

export const Tooltip = styled.p<{ isVisible: boolean }>`
  display: ${p => (p.isVisible ? "flex" : "none")};
  position: absolute;
  top: 20px;
  right: -11px;
  min-width: 150px;
  padding: 4px 12px;
  margin: 0;
  ${p => p.theme.typography.standard.size_11px.normal()}
  color: ${p => p.theme.colors.failureMedium};
  background-color: ${p => p.theme.colors.failureExtraLight};
  border: 1px solid ${p => p.theme.colors.failureExtraLight};
  border-radius: 2px;

  &:before {
    display: block;
    content: "";
    border: 8px solid transparent;
    border-bottom-color: ${p => p.theme.colors.failureExtraLight};
    margin: 0;
    width: 0;
    height: 0;
    position: absolute;
    top: -15px;
    right: 10px;
  }
`
